import { useNavigate, useRouter } from "@tanstack/react-router";
import { Button } from "@/components/common";

interface ErrorPageProps {
  error: Error;
  reset?: () => void;
}

export function ErrorPage({ error, reset }: ErrorPageProps) {
  const navigate = useNavigate();
  const router = useRouter();

  const handleReset = () => {
    if (reset) {
      reset();
    }
    void router.invalidate();
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-subtle px-4">
      <p className="mb-2 text-sm font-medium tracking-widest text-adara-500 uppercase">
        Błąd
      </p>

      <h1 className="mb-3 text-7xl font-bold text-adara-900">500</h1>

      <p className="mb-2 max-w-md text-center text-dim">
        Wystąpił nieoczekiwany błąd. Spróbuj odświeżyć stronę.
      </p>

      {import.meta.env.DEV && (
        <pre className="mb-8 max-w-lg overflow-auto rounded bg-muted px-4 py-3 text-left font-mono text-xs text-sub">
          {error.message}
        </pre>
      )}

      {!import.meta.env.DEV && <div className="mb-8" />}

      <div className="flex gap-3">
        <Button variant="primary" onClick={handleReset}>
          Spróbuj ponownie
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            void navigate({ to: "/" });
          }}
        >
          Strona główna
        </Button>
      </div>

      <div className="mt-12">
        <img
          src="/logos/adara-logo.svg"
          alt="Adara"
          className="h-8 opacity-30"
        />
      </div>
    </div>
  );
}
